/**
 * Extract a user-facing error message from a raw JSON payload - either an HTTP
 * error body or the data of an SSE "error" event. The backend only includes a
 * `message` for errors that are safe to show the user; everything else falls
 * back to the given generic message.
 */
export const extractAiErrorMessage = (rawData, fallback) => {
  try {
    return JSON.parse(rawData)?.message ?? fallback;
  } catch {
    return fallback;
  }
};
